// src/pages/CalendarPage.tsx
import React, { useState, useEffect, useCallback } from 'react';
import { Card, Typography, Select, Row, Col } from 'antd';
import { UnifiedCalendar } from '../components/UnifiedCalendar';
import { doctorsAPI } from '../utils/api';
import { useAuth } from '../App';

const { Title, Text } = Typography;

export const CalendarPage: React.FC = () => {
  const { user } = useAuth();
  const [selectedPatientId, setSelectedPatientId] = useState<number | null>(null);
  const [patients, setPatients] = useState<any[]>([]);

  const getPatientDisplayName = (patient: any) => {
    const name = patient?.full_name?.trim?.() || patient?.full_name;
    if (!name || String(name).startsWith('gAAAA')) {
      return `Пациентка #${patient?.patient_id ?? patient?.id ?? '—'}`;
    }
    return name;
  };

  const loadDoctorPatients = useCallback(async () => {
    try {
      const response = await doctorsAPI.getPatients();
      const patientsData = (response.data || []) as any[];
      setPatients(patientsData);
      if (patientsData.length > 0 && !selectedPatientId) {
        setSelectedPatientId(patientsData[0].patient_id);
      }
    } catch (error) {
      console.error('Error loading doctor patients:', error);
    }
  }, [selectedPatientId]);

  useEffect(() => {
    if (user?.role === 'doctor') {
      loadDoctorPatients();
    }
  }, [user, loadDoctorPatients]);

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ color: '#263238' }}>Календарь записей</Title>
        <Text type="secondary">
          Просмотр всех записей дневников в едином календаре
        </Text>
      </div>

      {user?.role === 'doctor' && (
        <Card style={{ marginBottom: 24, borderRadius: '12px' }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={4} style={{ margin: 0, color: '#263238' }}>Выбор пациента</Title>
            </Col>
            <Col>
              <Select
                placeholder="Выберите пациента"
                style={{ width: 300 }}
                onChange={(value) => setSelectedPatientId(value)}
                value={selectedPatientId}
                options={patients.map((p) => ({ value: p.patient_id, label: getPatientDisplayName(p) }))}
              />
            </Col>
          </Row>
        </Card>
      )}

      <UnifiedCalendar selectedPatientId={selectedPatientId} />
    </div>
  );
};
